import {
  Theme,
  TextLink,
  TextLinkIconPosition,
  TextLinkUnderlineStyle,
  TextLinkStyle,
} from '@nextgen-web-framework/all';
import { DownloadCardIconName, type DownloadCardProps } from './types/propsTypes';
import styles from './DownloadCard.module.scss';
const DownloadCard = (props: DownloadCardProps) => (
  <div className={styles['downloadcard-container']}>
    <TextLink
      text={props?.label as string}
      theme={Theme.PURPLE}
      iconPosition={TextLinkIconPosition.RIGHT}
      underline={TextLinkUnderlineStyle.FIXED}
      rightIcon={{ iconName: DownloadCardIconName.FILE_DOWNLOAD }}
      textLinkStyle={TextLinkStyle.ICON}
      href={props.url}
      target={props.target}
    />
  </div>
);
export default DownloadCard;
